import React, { Component } from "react";
import styled from "styled-components";
import { colors } from "../utils/helpers";

const ContenedorMancheta = styled.div`
	margin: 0 auto;
	width: 180px;
	padding: 0;
`;

const DC = styled.svg`
	margin-top: 1.5em;
	width: 180px;
	height: 40px;
	cursor: pointer;
`;

export default class Mancheta extends Component {
	render() {
		return (
			<ContenedorMancheta>
				<DC>
					<a
						href="http://www.diariodecadiz.es/semana_santa/cuaresma/"
						alt="Diario de Cádiz"
						target="_blank"
						rel="noopener noreferrer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129.9 22">
							<path
								d="M10.6 3C9.3 1.7 7.8 1.7 6.3 1.7H1.5V3h.8c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1h-.8v1.4h4.4c1.9 0 2.9-.1 3.8-.6 1.8-1.1 2.8-3.3 2.8-6.2-.1-2.5-.7-4.4-1.9-5.7zM9.4 8.5c0 5.2-1.4 5.6-3.1 5.6H6c-.3 0-.3-.2-.3-.8V4c-.1-1 .1-1 .5-1h.5c1.9 0 2.7 1.6 2.7 5.5zM44.2 13V4.2c0-1.1 0-1.1.6-1.1h1V1.7H40V3h.9c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1h-1c-.8 0-.8 0-1.1-.9l-.8-2.3c-.6-1.4-1-1.9-1.4-2.2 2.1-.7 2.3-2.6 2.3-3.5 0-1.4-.7-2.6-1.7-3.2-.8-.4-1.5-.4-2.7-.4H29V3h.8c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1h-1.1c-.5 0-.6 0-.9-.9L24.1 1.3h-1.3l-3.7 11c-.5 1.6-.8 1.8-1.4 1.8h-.9c-.6 0-.6 0-.6-1.1V4.2c0-1.1 0-1.1.6-1.1h1V1.7H12V3h.9c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1H12v1.4h9.9v-1.4h-.5c-.3 0-1-.1-1-.9 0-.3.1-.9.2-1.1l.2-.6h3.8l.5 1.4v.1c.1.2.1.5.1.7 0 .3-.2.4-.6.4h-.9v1.4h11.1v-1.4h-.9c-.6 0-.6 0-.6-1.1V9.3h.4c.8 0 1 .1 1.2 1l1.7 5.2h9.1v-1.4h-1c-.5 0-.5 0-.5-1.1zm-11-9.2c0-.8.2-.8.4-.8h.3c1.1 0 2 .3 2 2.3 0 2.6-1 2.6-2.3 2.6h-.5l.1-4.1zm-9.1 6.3h-2.9l1.5-4.4 1.4 4.4zm26.7-8.8c-4.2 0-5.4 4.5-5.4 7.1 0 3.4 1.4 7.3 5.3 7.3 4.3 0 5.4-4.5 5.4-7.2.1-.6-.1-7.2-5.3-7.2zm0 13.1c-1.6 0-2.3-1.7-2.3-5.9 0-4 .7-5.8 2.2-5.8 1.1 0 2.3.6 2.3 5.6.1 4.3-.6 6.1-2.2 6.1zM68.3 3C67 1.7 65.5 1.7 64 1.7h-4.8V3h.8c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1h-.8v1.4h4.4c1.9 0 2.9-.1 3.8-.6 1.8-1.1 2.8-3.3 2.8-6.2-.1-2.5-.7-4.4-1.9-5.7zm-4.6 11.1c-.3 0-.3-.2-.3-.8V4c-.1-1 .1-1 .5-1h.5c1.9 0 2.7 1.6 2.7 5.5 0 5.2-1.4 5.6-3.1 5.6h-.3zm14.5-4h1.1l-.2 5.3h-9.5V14h.8c.6 0 .6 0 .6-1.1V4.2C71 3 71 3 70.4 3h-.8V1.7h9.2l.2 5h-1.1v-.2c-.4-3.3-1.4-3.5-3-3.5h-.6c-.5 0-.6 0-.6.8v3.9h.2c1.1 0 1.6-.7 1.6-2.3v-.2h1.2v6.5h-1.2v-.2c0-2.1-.5-2.5-1.6-2.5h-.1v4.1c0 1 .1 1 .4 1h.9c.9 0 1.9 0 2.5-1.5.3-.7.5-1.4.5-2.3.1 0 .1-.2.1-.2zm14.3.6c-.2 1.8-1.3 5.1-4.6 5.1-3.1 0-5.2-2.7-5.2-6.9 0-1.8.4-7.5 5.6-7.5 1.1 0 2.7.3 3.7 1.1l.1.1.2 4.2H91v-.2c-.3-3.2-1.5-3.8-2.4-3.8-2.5 0-2.8 4.1-2.8 5.8 0 3.6.9 5.5 2.6 5.5 1.4 0 2.5-1.3 2.8-3.4v-.2h1.2l.1.2zM112.4 3c-1.3-1.4-2.8-1.4-4.3-1.4h-4.8V3h.8c.6 0 .6 0 .6 1.1V13c0 1.1 0 1.1-.6 1.1H103c-.5 0-.6 0-.9-.9L98.3 1.3H97l-3.7 11c-.5 1.6-.8 1.8-1.4 1.8h-.2v1.4H96v-1.4h-.5c-.3 0-1-.1-1-.9 0-.3.2-.9.2-1.1l.2-.6h3.8l.4 1.4v.1c.1.2.2.5.2.7 0 .3-.2.4-.6.4h-.9v1.4h9.8c1.9 0 2.9-.1 3.8-.6 1.8-1.1 2.8-3.3 2.8-6.2 0-2.5-.6-4.4-1.8-5.7zm-4.9 1c0-.9.1-.9.5-.9h.5c1.9 0 2.7 1.6 2.7 5.5 0 5.2-1.4 5.6-3.1 5.6h-.3c-.3 0-.3-.2-.3-.8V4zm-9.2 6.1h-2.9l1.5-4.4 1.4 4.4zm15.3-8.4h5.8V3h-1c-.6 0-.6 0-.6 1.1V13c0 1.1 0 1.1.6 1.1h1v1.4h-5.8v-1.4h.9c.6 0 .6 0 .6-1.1V4.2c0-1.1 0-1.1-.6-1.1h-.9V1.7zm15 8.4l-.2 5.4h-8.6v-1.2L125.4 3h-1.1c-1.1 0-2.6 0-3 3.5v.2h-1.2l.2-5h8.2v1.2l-5.6 11.2h1.3c1.6 0 2.7 0 3.3-3.8v-.2h1.1z"
								fill={colors.black}
							/>
							<path fill={colors.main} d="M1 20.9v-3.1h127.5v3.1z" />
						</svg>
					</a>
				</DC>
			</ContenedorMancheta>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Mancheta.js